import { Injectable, EventEmitter } from '@angular/core'
import { ModalConfig } from './modal.model';
import { FormGroup } from '@angular/forms';

@Injectable()
export class ModalService {

    modalConfig = new EventEmitter<ModalConfig>()
    form: FormGroup
    filterform: FormGroup
    callback: any
    constructor() { }

}
